import React, { useState } from 'react';
import MusicPlayer from './components/MusicPlayer';
import Header from './components/Header';
import CardGrid from './components/CardGrid';
import Modal from './components/Modal';
import Notification from './components/Notification';
import IntroSequence from './components/IntroSequence';
import SimpleDrawingBoard from './components/SimpleDrawingBoard';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

function App() {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState('');
  const [showIntro, setShowIntro] = useState(true);
  const [showPixelBoard, setShowPixelBoard] = useState(false);

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  const handleEasterEgg = (message) => {
    setNotification(message);
  };

  const handleCloseNotification = () => {
    setNotification('');
  };

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <div className={`App ${!showIntro ? 'main-content' : ''}`}>
      {/* La música debe sonar desde el inicio, pero el reproductor se oculta durante la intro */}
      <MusicPlayer onVolumeEasterEgg={handleEasterEgg} isVisible={!showIntro} />
      
      {/* Mostrar la secuencia de introducción primero */}
      {showIntro ? (
        <IntroSequence onComplete={handleIntroComplete} />
      ) : showPixelBoard ? (
        /* Vista del Pizarrón Mágico */
        <SimpleDrawingBoard onBack={() => setShowPixelBoard(false)} />
      ) : (
        /* Vista principal con las cards */
        <>
          <Header onEasterEgg={handleEasterEgg} />
          
          <CardGrid 
            onCardClick={handleCardClick} 
            onEasterEgg={handleEasterEgg}
            onOpenDrawingBoard={() => setShowPixelBoard(true)}
          />
          
          <Modal 
            isOpen={isModalOpen} 
            onClose={handleCloseModal} 
            card={selectedCard} 
          />
        </>
      )}
      
      <Notification 
        message={notification} 
        onClose={handleCloseNotification} 
      />
    </div>
  );
}

export default App;
